module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/VQBwwE/tc-custom/9781398421653.jpg?1705688281874",
      "alt": "This image is the cover for the book Dead? Undead? Limbering Bastards"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Dead? Undead? Limbering Bastards\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("What would you do if you found yourself stranded miles from home and your family during a sudden and unexplained virus outbreak? People are dying all around you… while others are quickly coming back to life as the limbering undead… complete with a ravenous hunger and thirst for human blood. You need to get home… you need to know if your family are safe… but can you really survive the swelling hordes of the limbering undead… not to mention other survivors.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      John McNeil\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("John lives in a small town in the west of Scotland, where he was born and bred. He is a dedicated family man who is revelling in his new found role as a first-time grandad. When he’s not working hard for a living, he likes to spend his spare time writing (short stories mostly). He likes to read (and write) about horror, mysteries and things unexplained. Having said that, he will read (and write) about mostly anything. Apart from romantic affairs of the heart slushy stuff that is (he leaves that sort of stuff to others), he likes graphic, dark and somewhat twisted and bizarre stories that are meant to shock the reader. Stories that make you go, “Whoa…what the hell did I just read!!!”")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Austin Macauley Publishers\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0